import React from "react";

const HomePage = () => {
  return (
    <div style={{ width: "100%", padding: "20px" }}>
      <div style={{ width: "100%", height: "600px" }}>
        <iframe
          title="Data Statis"
          width="100%"
          height="100%"
          src="https://lookerstudio.google.com/embed/reporting/4d9e7ed1-842b-4779-8261-654e2eeff4ac/page/1M"
          style={{ border: 0 }}
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default HomePage;
